export const environment = {
    production: true,
    envName: 'dev',
    baseUrl: 'https://api-dev.centilytics.com/v2',
    wsBaseUrl: 'wss://api-dev.centilytics.com/ws',
    mock: false, // set this to true to use mock server to develop a widget
    mockComponent: null // set this to the component to render in case of MOCK_WIDGET PortletType
};
